import styled, { css } from 'styled-components';

import { Text } from 'shared/components/Text/Text';

export const Form = styled.form`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    padding: 16px;
    gap: 16px;
    border-radius: 24px;
    border: 1px solid ${theme.colors.strokeSecondaryGrey10};
    background: ${theme.colors.backgroundSecondaryGrey05};
  `}

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.small}) {
    padding: 20px;
    button {
      margin: 8px 0;
    }
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.large}) {
    padding: 24px;
  }
`;

export const Title = styled(Text)`
  font-family: Avenir;
  font-size: 16px;
  font-weight: 800;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.textPrimarySecondary1100};

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.small}) {
    font-size: 20px;
    font-weight: 500;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.large}) {
    font-size: 24px;
    margin-bottom: 4px;
  }
`;

export const CallUsWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;

  p {
    z-index: 1;
    background: ${({ theme }) => theme.colors.backgroundSecondaryGrey05};
    padding: 0 12px;
  }

  hr {
    position: absolute;
    top: 50%;
  }
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  z-index: 1;
  padding: 0 42px;
  p {
    text-align: center;
  }
`;

export const BodyText = styled(Text)<{ $isBold?: boolean }>`
  display: inline-block;
  font-family: Avenir;
  font-weight: ${({ $isBold }) => ($isBold ? 800 : 300)};
  line-height: 24px;
  color: ${({ theme }) => theme.colors.textPrimarySecondary1100};

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.large}) {
    margin-bottom: 8px;
  }
`;

export const SupportFormContainer = styled.form`
  background: ${({ theme }) => theme.colors.backgroundSecondaryGrey05};
  display: flex;
  flex-direction: row;
  margin-top: 24px;
  padding: 32px;
  border-radius: 24px;
  width: 100%;
`;

export const SupportFormCard = styled.div`
  flex: 2;
`;

export const SupportFormDescriptionItem = styled.div`
  margin-top: 12px;
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  font-weight: 300;
  color: ${({ theme }) => theme.colors.textPrimarySecondary1100};
`;

export const SupportFormInfoContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const ContactInfoIconContainer = styled.div`
  background: ${({ theme }) => theme.colors.cardElevationMidWhite};
  border-radius: 50px;
  border: 1px solid ${({ theme }) => theme.colors.strokeSecondaryGrey10};
  width: 34px;
  height: 34px;
  margin-right: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.colors.iconIconPrimarySecondary1100};
  padding: 4px 8px 6px 8px;
`;
